import { Edit as EditIcon } from '@mui/icons-material';
import { Box, Table, TableBody, TableCell, TableHead, TableRow } from "@mui/material";

const MotorList = ({ dadosLojaOnline, handleEditModal, quantityFiltered = 0 }) => {

  const formatarData = (d) => {
      if (!d) return "";
      const data = new Date(d);
      const dia = String(data.getUTCDate()).padStart(2, "0");
      const mes = String(data.getUTCMonth() + 1).padStart(2, "0");
      const ano = data.getUTCFullYear();
      return `${dia}/${mes}/${ano}`;
  };

  const getStatusColor = (status) => {
    if(status){
      // switch (status) {
      //   case "REALIZADO":
      //     return "#38761d"
      //   case "PENDENTE":
      //     return "#FFFFFF"
      //   case "CANCELADO":
      //     return "#ff0000"
      //   case "PARCIALMENTE CONCLUÍDO":
      //     return "#FFFF00"
      //   default:
      //     break;
      // }
      // switch (status) {
      //   case "REALIZADO":
      //     return {color: "#008009", fontSize: "34px"}
      //   case "PENDENTE":
      //     return {color: "#c4c4c4ff", fontSize: "34px"}
      //   case "CANCELADO":
      //     return {color: "#E40D0D", fontSize: "34px"}
      //   case "PARCIALMENTE CONCLUÍDO":
      //     return {color: "#F59E0B", fontSize: "34px"}
      //   default:
      //     console.log("default")
      //     return {display: "none"};
      // }
      switch (status) {
        case "REALIZADO":
          return {color: "#FFFFFF", backgroundColor: "#008009"}
        case "PENDENTE":
          return {color: "#BABABA", backgroundColor: "#FFFFFF", border: "1px solid #BABABA"}
        case "CANCELADO":
          return {color: "#FFFFFF", backgroundColor: "#FF0000"}
        case "PARCIALMENTE CONCLUÍDO":
          return {color: "#FFFFFF", backgroundColor: "#F59E0B"}
        default:
          return {color: "#000000"};
      }
    }
    return {color: "#000000"};
  }

  const tableCellStyle = {
    textAlign: 'center',
    padding: '8px'
  }

  const tableCellHeaderStyle = {
    textAlign: 'center',
    padding: '8px',
    fontWeight: 'bold',
  }

  return (
    <Box sx={{ width: "100%", maxHeight: "70vh" }} overflow="auto">
      <Table stickyHeader stripedRows>
        <TableHead>
          <TableRow>
            <TableCell sx={tableCellHeaderStyle}>Nº Reserva</TableCell>
            <TableCell sx={tableCellHeaderStyle}>Cód. Referência</TableCell>
            <TableCell sx={tableCellHeaderStyle}>Data de Criação</TableCell>
            <TableCell sx={tableCellHeaderStyle}>Check-in</TableCell>
            <TableCell sx={tableCellHeaderStyle}>Check-out</TableCell>
            <TableCell sx={tableCellHeaderStyle}>Status Reserva</TableCell>
            <TableCell sx={tableCellHeaderStyle}>Tipo de Reserva</TableCell>
            <TableCell sx={tableCellHeaderStyle}>Forma de Pagamento</TableCell>
            <TableCell sx={tableCellHeaderStyle}>Promotor</TableCell>
            <TableCell sx={tableCellHeaderStyle}>Motivo Cancelamento</TableCell>
            {/* <TableCell sx={tableCellHeaderStyle}>Consultor Responsável</TableCell> */}
            <TableCell sx={tableCellHeaderStyle}>Status</TableCell>
            <TableCell sx={tableCellHeaderStyle}>Observação</TableCell>
            <TableCell sx={tableCellHeaderStyle}>Ações</TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {dadosLojaOnline.length === 0 ? (
            <TableRow>
              <TableCell colSpan={14} align="center" sx={{ py: 4, fontStyle: "italic", color: "gray" }}>
                {quantityFiltered > 0
                  ? "Nenhuma reserva encontrada com os filtros aplicados. Ajuste os filtros ou amplie o período."
                  : "Nenhuma reserva encontrada no período. Troque o critério (Criação / Check-in / Check-out) ou amplie as datas."}
              </TableCell>
            </TableRow>
          ) : (
            dadosLojaOnline.map((item) => (
              <TableRow key={item.numreserva} hover>
                <TableCell sx={tableCellStyle}>{item.numreserva}</TableCell>
                <TableCell sx={tableCellStyle}>{item.codreferencia}</TableCell>
                <TableCell sx={tableCellStyle}>{formatarData(item.data_reserva)}</TableCell>
                <TableCell sx={tableCellStyle}>{formatarData(item.checkin)}</TableCell>
                <TableCell sx={tableCellStyle}>{formatarData(item.checkout)}</TableCell>
                <TableCell sx={tableCellStyle}>{item.status_reserva}</TableCell>
                <TableCell sx={tableCellStyle}>{item.tipo_reserva}</TableCell>
                <TableCell sx={tableCellStyle}>{item.forma_pagamento}</TableCell>
                <TableCell sx={tableCellStyle}>{item.nome_promotor}</TableCell>
                <TableCell sx={tableCellStyle}>{item.motivo_cancelamento}</TableCell>
                {/* <TableCell sx={tableCellStyle}>{item.consultor_responsavel}</TableCell> */}
                {/* <TableCell><CircleIcon sx={getStatusColor(item.status)} /></TableCell> */}
                <TableCell sx={tableCellStyle}>
                  <Box
                    sx={{
                      ...getStatusColor(item.status),
                      borderRadius: "8px",
                      padding: "10px 4px",
                      fontWeight: "700",
                      textAlign: "center"
                    }}
                  >
                    {item.status}
                  </Box>
                </TableCell>
                <TableCell sx={tableCellStyle}>{item.observacao}</TableCell>
                <TableCell sx={tableCellStyle}>
                  <EditIcon
                    sx={{ height: 34, cursor: "pointer" }}
                    onClick={() => handleEditModal(item)}
                  />
                </TableCell>
              </TableRow>
            ))
          )}
        </TableBody>
      </Table>
    </Box>
  );
};

export default MotorList;
